<template>
  <div class="tradeTable">
    <el-table
      :data="trade"
      stripe
      :header-row-style="bg"
      style="width:100%"
    >
      <el-table-column
        prop="ref_order_id"
        label="订单编号"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型"
        header-align="center"
        align="center">
        <template slot-scope="scope">
          <div>{{scope.row.type==1 ? '收入': scope.row.type ==  '3'  ? '提现金额' : '支出'}}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额(元)"
        :formatter="tofixed"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="store_id"
        label="门店"
        header-align="center"
        align="center">
        <template slot-scope="scope">
          <div>{{scope.row.store_id==1 ? '数据中心': '默认门店'}}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subject"
        label="来源"
        header-align="center"
        align="center">
         <template slot-scope="scope" >
          <span
            size="medium"
            type="text"
            v-show="scope.row.type == 1">
            {{scope.row.subject}}
          </span>
          <span
            size="medium"
            type="text"
            v-show="scope.row.type == 5"
            class="btnText"
          >
            退款-{{scope.row.subject}}
          </span>
          <span
            size="medium"
            type="text"
            v-show="scope.row.type == 6"
            class="btnText"
          >
            {{scope.row.subject}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        v-if="mchId == '2985139383174144'"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="count"
        label="用餐人数"
        v-if="mchId == '2985139383174144'"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="时间"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center">
        <template slot-scope="scope" >
          <el-button
            size="medium"
            type="text"
            v-show="scope.row.type == 1"
            @click="AddRatee(scope.row.ref_order_id,scope.row.amount,scope.row.subject,scope.row.channel,scope.row.createTime)">
            退款
          </el-button>
          <el-button
            size="medium"
            type="text"
            v-show="scope.row.type == 5"
            @click="toViewDetail(scope.row.ref_order_id)"
            >
            退款详情
          </el-button>
          <el-button
            size="medium"
            type="text"
            v-show="scope.row.type == 6"
            @click="toViewDetail(scope.row.ref_order_id)"
            >
            退款详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 发起退款弹框 -->
    <el-dialog 
      title="发起退款" 
      width="558px" 
      customClass="customWidth"  
      :visible.sync="dialogFormVisible"
      :before-close="close"
      >
      <div class="border"></div>
      <el-form 
        label-width="50" 
        class="bounced"
        ref="form"
        :inline="true"
      >
        <div class="amount">
          <span class="amount-name">支付金额 :</span>
          <span class="amount-value"> ￥<span class="refundTotal">{{this.tofix(refundDetail.amount)}}</span></span>
        </div>
        <div class="userName">
          <span class="name">用户名：{{refundDetail.subject}}</span>
          <span class="mothods">支付渠道：{{this.refundFormat(refundDetail.channel)}}</span>
        </div>
        <div class="payDate">
          <span class="date">支付时间：{{refundDetail.createTime}}</span>
          <span class="number">订单编号：{{refundDetail.orderId}}</span>
        </div>
        <div class="warn">
          <div class="text1">
            <i class="icon"></i>
            <span class="text">退款金额将会原路退回到用户的支付渠道</span>
          </div>
          <div class="text2">注：支付宝订单退款需扣除0.6%的收费，微信与园区订单退款不收取手续费</div>
        </div>
        <div class="refund " v-show="refundDetail.refundAmount">
        <!-- <div class="refund "> -->
          <span class="refundAmount">当前已退款金额：<span class="refundColor">{{this.tofix(refundDetail.refundAmount)}}</span></span>
          <span class="remainingAmount">可退款金额：<span class="refundColor">{{refundDetail.amount - refundDetail.refundAmount}}</span></span>
          <span class="serchRecord" @click="searchRecode(refundDetail.orderId)">查看退款记录</span>
        </div>
        <el-row class="EnterRefundAmount" v-show="isBtn">
          <el-col :span="16" class="inputBox">
            <el-form-item label="退款金额" class="RefundInput">
              <el-input  placeholder="请输入退款金额" v-model="inputVal"></el-input>
            </el-form-item>
            <div v-show="this.refundDetail.channel == '3'" class="poundage">退款手续费{{this.tofix(this.inputVal*0.006)}}</div>   
          </el-col>
          <el-col :span="2" class="unit">
            <span>元</span> 
          </el-col>
          <el-col :span="5" class="button">
              <el-button class="fullRefund" @click="assignment(refundDetail.amount)">全部退款</el-button>
          </el-col>
        </el-row>  
        <el-form-item label="退款备注" class="btm" v-show="isBtn">
          <el-input 
          type="textarea" 
          placeholder="请输入退款备注（选填）" 
          :rows="4" style="width:320px;"
          v-model="textarea"
          ></el-input>
          <div class="error" :class="{'hidden':error}">退款金额不可超出用户支付金额</div>
        </el-form-item>
        <el-form-item  align="center" class="form-button">
          <el-button type="success"  class="form-submit" v-show="isBtn" @click="submit">确认退款</el-button>
          <el-button type="success"  class="form-submit" v-show="!isBtn" @click="closeSubmit">关闭</el-button>
        </el-form-item>
      </el-form>
		</el-dialog>
    <!-- 退款成功提示弹框 -->
    <el-dialog 
      title="退款详情" 
      width="558px" 
      class="detailsRefund"
      :visible.sync="refundSuccess">
      <el-form 
        label-width="50" 
        class="bounced"
        ref="form"
        :inline="true"
      >
        <div class="successLogo" :class="{'succ':Sactive}">
          <i class="icon"></i>
          <div class="text">
            <span class="textname">退款成功</span>
            <span class="textDetail">退款金额 : ￥<span class="refundTotal">{{this.tofix(refundSuccDetail.refundAmount)}}</span></span>
          </div>
        </div>
        <div class="waitingLogo" :class="{'wucc':Wactive}">
          <i class="icon"></i>
          <div class="text">
            <span class="textname">入账中</span>
            <span class="textDetail">退款金额 : ￥<span class="refundTotal">{{this.tofix(refundSuccDetail.refundAmount)}}</span></span>
          </div>
        </div>
        <div class="userName">
          <span class="name">用户名 ：{{refundSuccDetail.username}}</span>
          <span class="money">订单金额 ：{{this.tofix(refundSuccDetail.orderAmount/100)}}</span>
        </div>
        <div class="refundMothod">
          <span class="mothod">退款渠道 ：{{refundRecordData.channel == 1?'园区钱包':refundRecordData.channel == 2?'微信支付':'支付宝支付'}}</span>
          <span class="proson">处理人 ：{{refundSuccDetail.handlerName}}</span>
        </div>
        <div class="refundDate">
          <span class="refundTime">退款时间 ：{{refundSuccDetail.createTime}}</span>
          <span class="arriveTime">到账时间 ：{{refundSuccDetail.updateTime}}</span>
        </div>
        <div class="orderId">
          <span class="text">原订单编号 ：{{refundSuccDetail.orderId}}</span>
          <span class="text">订单编号 ：{{refundSuccDetail.refundOrderId}}</span>
        </div>   
        <div class="refundNote">
          <span class="refundNoteName">订单备注 ：</span>
          <span class="refundNoteText">{{refundSuccDetail.desc}}</span>
        </div>
        <el-form-item  align="center" class="form-button" >
          <el-button type="success" @click="closeSuc">关闭</el-button>
        </el-form-item>
      </el-form>
		</el-dialog>
    <!-- 退款详情弹框 -->
    <el-dialog 
      title="退款详情" 
      width="558px" 
      :visible.sync="refundRecord">
      <el-form 
        label-width="50" 
        class="record"
        ref="form"
        :inline="true"
      >
        <div class="dataList">
          <div class="refundDate">
            <span class="refundTime">订单金额 ：￥{{refundRecordData.orderAmount?refundRecordData.orderAmount:0}}</span>
            <span class="refundTime">退款金额 ：￥{{refundRecordData.refundAmount?refundRecordData.refundAmount:0}}</span>
          </div> 
          <div class="refundDate" v-show="refundRecordData.channel == 3">
            <span class="refundTime" >退款手续费 ：{{refundRecordData.fee}}</span>
          </div>      
          <div class="refundDate">
            <span class="refundTime">退款渠道 ：{{refundRecordData.channel == 1?'园区钱包':refundRecordData.channel == 2?'微信支付':'支付宝支付'}}</span>
             <span class="refundTime">退款状态 ：{{refundRecordData.status == 1?'退款成功':'待入账'}}</span>
          </div>
          <div class="refundMothod">
            <span class="proson">用户名称 ：{{refundRecordData.realname}}</span>
            <span class="proson">操作人 ：{{refundRecordData.handlerName}}</span>
          </div>
          <div class="refundDate">
            <span class="refundTime">退款时间 ：{{refundRecordData.createTime}}</span>
            <span class="refundTime">到账时间 ：{{refundRecordData.updateTime}}</span>
          </div>
          <div class="orderId">
            <span class="text">退款编号 ：{{refundRecordData.refundOrderId}}</span>
          </div> 
          <div class="oldOrderId">
            <span class="text">
              <span class="number">原订单编号 ：<span id="target">{{refundRecordData.sourceOrderId}}</span></span> 
              <span class="font" @click="copyOrderId" data-clipboard-target="#target">复制</span>
              </span>
          </div>   
          <div class="refundNote">
            <span class="refundNoteName">退款备注 ：</span>
            <span class="refundNoteText">{{refundRecordData.desc?refundRecordData.desc:'无'}}</span>
          </div>
        </div>
      </el-form>
		</el-dialog>
    <!-- 退款记录弹框 -->
    <el-dialog 
      title="退款记录" 
      width="558px" 
      :visible.sync="recordNum">
      <el-form 
        label-width="50" 
        class="recordes"
        :inline="true"
      >
        <div class="top">
          <span class="topOne">退款总数 <span class='color'>{{refundRecordDataRecord.length}}</span>次</span>   
          <span class="topTwo">退款总额: <span class='color'>￥{{sum}}</span></span>   
          </div>
        <div class="dataList" v-for="item in refundRecordDataRecord" :key="item.refundOrderId">
          <div class="refundDate">
            <span class="refundTime">退款金额 ：￥{{item.refundAmount?item.refundAmount:0}}</span>
             <span class="refundTime">退款渠道 ：{{item.channel == 1?'园区钱包':item.channel == 2?'微信支付':'支付宝支付'}}</span>
          </div> 
          <div class="refundDate" v-show="item.channel == 3">
            <span class="refundTime" >退款手续费 ：{{item.fee}}</span>
          </div>      
          <div class="refundDate">
            <span class="refundTime">退款时间 ：{{item.createTime}}</span>
            <span class="proson">操作人 ：{{item.refundUsername}}</span>
          </div>
          <div class="orderId">
            <span class="text">退款编号 ：<span id="targets">{{item.refundOrderId}}</span></span>
            <span class="font" @click="copyOrderId" data-clipboard-target="#targets">复制</span>
          </div>   
          <div class="refundNote">
            <span class="refundNoteName">退款备注 ：</span>
            <span class="refundNoteText">{{item.desc?item.desc:'无'}}</span>
          </div>
        </div>
        <div class="bottom">
           <el-button type="success"  class="btn"  @click="closeRecord">关闭</el-button>
        </div>
      </el-form>
		</el-dialog>
  </div>
</template>
<script>
import { tradeDataOrder, refundDetail, refundForm, refundRecord} from '@/api/trade'
import { toFloat } from '@/utils';
import Clipboard from 'clipboard'  
export default {
  props: ['trade'],
  data () {
    return {
      bg: {
        'background-color': '#fafafa'
      },
      mchId: '',
      error: true,
      inputVal: '',
      textarea: '',
      dialogFormVisible: false,
      refundSuccess: false,
      hidden: true,
      phone: '',
      refundDetail: {},
      refundSuccDetail: {},
      Sactive: true,
      Wactive: false,
      refundRecord: false,
      refundRecordData: {},
      refundRecordDataRecord: {},
      recordNum: false,
      sum: '',
      isBtn: true
    }
  },
  mounted () {
    this.mchId = this.$store.getters.mchId
    this._getPhone()
    console.log(this.trade)
  },
  methods: {
    tofixed (row, column, cellValue) {
      return toFloat(cellValue)
    },
    refundFormat (val) {
      let str = '';
      switch (val) {
        case 1:
          str = '园区支付';
          break
        case 2:
          str = '微信';
          break
        case 3:
          str = '支付宝';
          break
        case 4:
          str = '--';
          break
      }
      return str
    },
    AddRatee (orderId) {
      // console.log(orderId)
      this._getPhone()
      refundForm(orderId).then(res => {
        // console.log(res)
        this.refundDetail = res.data
        // console.log(this.refundDetail)
        this.dialogFormVisible = true
        this.isSubmitBtnShow()
      }).catch(error => {
        console.log(error)
      })
    },
    closeSuc () {
      this.refundSuccess = false
    },
    assignment (amount) {
      this.inputVal = amount
    },
    submit () {
      let money = this.inputVal;
      if(money === '' || money === null) {
        this.$message({
          message: '退款金额不能为空，请重新输入'
        });
        
      } else {
        let newMoney = Number(this.inputVal);
        if(this.isMoney (newMoney)){
          if(Number(this.inputVal) > Number(this.refundDetail.amount)) {
            this.error = false;
            setTimeout(() => {
              this.error = true;
            },3000);
            return;
          } 
          // let data = this.refundDetail;
          let data = {
            'amount':(this.inputVal*100).toFixed(0),
            'device':this.phone,
            'mchId':this.mchId,
            'orderId':this.refundDetail.orderId,
            'desc':this.textarea
          }
          console.log(data);
          this.refundDetail.remark = this.textarea;
          this.dialogFormVisible = false;
          tradeDataOrder(data).then(res => {
            console.log(res);
            if(res.data.msg == 'success') {
              this.refundSuccDetail = res.data.data;
              this.Sactive = false;
              this.Wactive = true;
              this.inputVal = '';
              this.textarea = '';
              setTimeout(() => {
                this.refundSuccess = true;
              },300);
            } else {
              this.$message({
                message: res.data.msg
              });
            }
            
          })
        } else {
          this.$message({
            message: '请重新输入正确的金额'
          });
        }
        
      } 
    },
    // 校验输入框格式
    isMoney (money) {
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (reg.test(money)) {
        return true
      } else {
        return false
      }
    },
    _getPhone () {
      const ua = window.navigator.userAgent
        if (ua.search(/iphone/i) != -1) {
          this.phone = 'iphone'
        } else if (ua.search(/android/i) != -1 || ua.search(/linux/i) != -1) {
          this.phone = 'android'
        } else {
          this.phone = 'other'
        }
    },
    tofix (val) {
      return toFloat(val)
    },
    getMyDate (str) {
      var oDate = new Date(str),
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth() + 1,
        oDay = oDate.getDate(),
        oHour = oDate.getHours(),
        oMin = oDate.getMinutes(),
        oSen = oDate.getSeconds(),
        oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':' + this.getzf(oSen)//最后拼接时间  
      return oTime  
    },
    // 补0操作
    getzf (num) {
      if (parseInt(num) < 10) {
        num = '0' + num  
      }
      return num  
    },
    // 复制退款单号
    copyOrderId () {
      var clipboard = new Clipboard('.font')  
      clipboard.on('success', e => {
        this.$message({
          message: '已复制到剪切板'
        })
        console.log('复制成功')//这里你如果引入了elementui的提示就可以用，没有就注释即可
        // 释放内存  
        clipboard.destroy() 
      })
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    toViewDetail (id) {
      refundDetail(id).then(res => {
        console.log(res)
        this.refundRecordData = res.data
        let handlerName = this.refundRecordData.handlerName;
        let realname = this.refundRecordData.realname;
        if(handlerName.constructor === Object) {
          this.refundRecordData.handlerName = this.refundRecordData.handlerName.realName;
        }
        if(realname.constructor === Object) {
          this.refundRecordData.realname = this.refundRecordData.realname.realName;
        }
        this.refundRecord = true
      }).catch(err => {
        console.log(err)
      })
    },
    close () {
      this.inputVal = ''
      this.dialogFormVisible = false
    },
    searchRecode (id) {
      refundRecord(id).then(res => {
        console.log(res)
        this.refundRecordDataRecord = res.data.data
        this.sum = res.data.sum
        this.recordNum = true
      })
    },
    // 提交按钮显示
    isSubmitBtnShow () {
      if (this.refundDetail.refundAmount == this.refundDetail.amount) {
        console.log(this.refundDetail.refundAmount, this.refundDetail.amount)
        this.isBtn = false
      } else {
        this.isBtn = true
      }
    },
    closeSubmit () {
      this.dialogFormVisible = false
    },
    closeRecord () {
      this.recordNum = false
    }
  }
}
</script>
<style lang="scss" scoped>
.tradeTable {
  // width: 100%;
  margin-top: 10px;
  margin: 0 20px;
}
.bgFa {
  background-color: #fafafa;
}
/deep/ .el-dialog__header {
    padding: 10px 20px;
    border-bottom:1px solid #E2E2E2;
    .el-dialog__headerbtn {
      position: absolute;
      top: 15px;
      right: 20px;
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
  }
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-button+.el-button {
  margin-left: 0px;
}

// 退款提示框样式
.bounced{
  box-sizing: border-box; 
  color:#323232;
  font-display: 'PingFang-SC-Medium';
  position: relative;
  padding-top: 20px;
  .amount{
    display: flex;
    font-size:18px;
    line-height:18px;
    padding:0 0 28px 0;
  }
  .userName{
    display: flex;
    font-size:14px;
    line-height:13px;
    padding:0 0 31px 0;
    .name{
      flex-basis: 50%;
    }
    .mothods{
      flex: 1;
    }
  }
  .payDate{
    display: flex;
    font-size:13px;
    line-height:12px;
    padding:0 0 31px 0;
    .date{
      flex-basis: 50%;
    }
    .number{
      flex: 1;
    }
  }
  .warn{
    color:#999;
    padding:0 0 31px 0;
    .text1{
      display: flex; 
      .icon{
        display: inline-block;
        width:14px;
        height:14px;
        background: url(../assets/images/warning.png) no-repeat;
        background-size:100%;
      }
      .text{
        flex:1;
        margin-left: 6px;
        font-size:13px;
        line-height: 14px;
      }
    }
    .text2{
      margin-top:5px;
      font-size:13px;
      line-height: 14px;
    } 
  }
  .refund{
    display: flex;
    font-size:13px;
    line-height:12px;
    padding:0 0 31px 0;
    .refundAmount{
      flex-basis: 40%;
    }
    .remainingAmount{
      flex-basis: 38%;
    }
    .serchRecord{
      flex: 1;
      color:#409EFF;
      cursor: pointer;
    }
    .refundColor{
      color:#FF3300;
    }
  }
  .error{
    font-family: 'MicrosoftYaHei';
    font-size: 13px;
    line-height: 12px;
    color:#FF3300;
    position: absolute;
    bottom:-25px;
    left:0;
  }
  
  .EnterRefundAmount{
    width:100%;
    height:auto;
    padding-bottom:10px;   
    .inputBox{
      position: relative;    
      .RefundInput{
        margin-right:0;
        /deep/ .el-form-item__label {
          text-align: right;
          vertical-align: middle;
          float: left;
          font-size: 13px;
          color: #606266;
          line-height: 40px;
          padding: 0 12px 0 0;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
      }
      .poundage{
        position: absolute;
        top:40px;
        left:60px;
        font-size: 13px;
        line-height: 12px;
        color:#FF3300;
        margin:10px 0 10px;
      }
    }
    .unit{
      font-size: 13px;
      height:40px;
      line-height: 40px;
      text-align: cneter;
    }
    .button{
      .fullRefund{
        border:1px solid #fff;
        color:#409EFF;
      }
    }
  }
  .btm{
    margin-bottom:0;
     /deep/ .el-form-item__label {
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 12px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
     }
  }
  .form-button{
    display: block;
    margin:0 auto;
    margin-top:20px;
    .form-submit{
      display: block;
      margin:0 auto;
      width:140px;
      height:38px;
      background:#30CF7F;
      border-color:#30CF7F;
    }
  }
  .form-button :hover{
    background: #30CF71;
  }
}
.hidden{display:none !important;}

// 退款成功提示框样式
.detailsRefund{
  height:auto;
  .successLogo{
    width:100%;
    height:40px;
    display: flex;
    padding-bottom:39px;
    .icon{
      flex-basis: 40px;
      width:40px;
      height:40px;
      background:url(../assets/images/succ.png) no-repeat;
      background-size: 100%;
    }
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .waitingLogo{
    width:100%;
    height:40px;
    display: flex;
    padding-bottom:39px;
    .icon{
      flex-basis: 40px;
      width:40px;
      height:40px;
      background:url(../assets/images/wait.png) no-repeat;
      background-size: 100%;
    }
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .userName{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .name{
      flex-basis: 50%;
    }
    .money{
      flex: 1;
    }
  }
  .refundMothod{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .mothod{
      flex-basis: 50%;
    }
    .proson{
      flex: 1;
    }
  }
  .refundDate{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .refundTime{
      flex-basis: 50%;
    }
    .arriveTime{
      flex: 1;
    }
  }
  .orderId{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .text{
      flex-basis: 50%;
    }
  }
  .refundNote{
    display: flex;
    font-size:12px;
    line-height:16px;
    padding:0 0 31px 0;
    .refundNoteName{
      flex-basis: 64px;
    }
    .refundNoteText{
      flex: 1;
    }
  }
  .succ{
    display:none;
  }
  .wucc{
    display:none;
  }
}
// 退款详情提示框样式
.record{
  height:auto;
  .total{
    width:100%;
    height:40px;
    display: flex;
    // padding-bottom:39px;
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .dataList{
    width:100%;
    height:auto;
    .userName{
      display: flex;
      font-size:12px;
      line-height:40px;
      .name{
        flex-basis: 35%;
      }
      .money{
        flex: 1;
      }
    }
    .refundMothod{
      display: flex;
      font-size:12px;
      line-height:40px;
      .mothod{
        flex-basis: 50%;
      }
      .proson{
        flex: 1;
      }
    }
    .refundDate{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundTime{
        flex-basis: 50%;
      }
      .arriveTime{
        flex: 1;
      }
    }
    .orderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 50%;
      }
    }
    .oldOrderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 100%;
        .font{
          cursor: pointer;
          color:#409EFF;
          margin-left:20px;
        }
      }
    }
    .refundNote{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundNoteName{
        flex-basis: 64px;
      }
      .refundNoteText{
        flex: 1;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding:0 20px 10px;
}
// 退款记录提示框样式
.recordes{ 
  .top{
    width:100%;
    height:40px;
    font-size: 14px;
    line-height: 40px;
    display: flex;
    border-bottom:1px solid #eee;
    .topOne{
      flex-basis: 30%;
    }
    .topTwo{
      flex: 1;
    }
    .color{
      color:#f00;
    }
  }
  .total{
    width:100%;
    height:40px;
    display: flex;
    padding-bottom:39px;
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .dataList{
    width:100%;
    height:auto;
    border-bottom:1px solid #eee;
    .userName{
      display: flex;
      font-size:12px;
      line-height:40px;
      .name{
        flex-basis: 35%;
      }
      .money{
        flex: 1;
      }
    }
    .refundMothod{
      display: flex;
      font-size:12px;
      line-height:40px;
      .mothod{
        flex-basis: 50%;
      }
      .proson{
        flex: 1;
      }
    }
    .refundDate{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundTime{
        flex-basis: 50%;
      }
      .arriveTime{
        flex: 1;
      }
    }
    .orderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 50%;
      }
      .font{
        color: #409EFF;
        cursor: pointer;
      }
    }
    
    .refundNote{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundNoteName{
        flex-basis: 64px;
      }
      .refundNoteText{
        flex: 1;
      }
    }
  }
  .bottom{
    display: block;
    margin: 0 auto;
    margin-top:10px;
    .btn{
      display: block;
      margin: 0 auto;
      width: 140px;
      height: 38px;
      background: #30CF7F;
      border-color: #30CF7F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TradeTable.vue